export class FiltroDashboardProfissiografico {
	idConcurso?: number;
	codigoOrgao?: number;
}
